namespace Areas.MyWorkflows {
    "use strict";
    
    let formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {
        formCrudOps = new FormCrudOperations("MyWorkflows")
    }

    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }

    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function deleteRecord() {
        formCrudOps.deleteRecord();
    }

    export function startProcess() {
        const verifyStart = window.confirm("Are you sure you would like to Start the Workflow Process for this record?");

        if (verifyStart) {
            const keyId: any = formCrudOps.form.option("KeyId");
            if (keyId != null) {
                sendRequest(`/${formCrudOps.area}/Edit/StartProcess/${keyId}`, "", "PUT");
            }
        }
    }

    export function onResponseContentReady(e) {
        restoreSubmittedResponse(e);
    }

    function restoreSubmittedResponse(e) {
        const submittalResponse: string = e.component.option("formData").SubmittalResponse;

        if (Areas.isEmpty(submittalResponse)) {
            return;
        }

        const responses = submittalResponse.split("|");
        const responseList: any = $("#ResponseList").dxList("instance");

        if (responseList) {
            const arrayStore: any = responseList.option("dataSource").store;

            const sItems = [];

            for (var i = 0; i < responses.length; i++) {
                const item = { id: responses[i], value: responses[i] };
                if (arrayStore.keyOf(item) !== null) {
                    sItems.push(item);
                }
            }

            responseList.option("selectedItems", sItems);
        }
    }

    export function onCellPrepared(e) {
        if (e.rowType === "data" && e.column.command === "edit") {
            if (e.data.actionTaken) {
                e.cellElement.empty();
            }
        }
    }

}
